/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useState, useEffect, useContext } from 'react';
import { IdentityContext } from "../IdentityContext";
import API from "../Utility";

export const ProjectContext = React.createContext();

export default function ProjectProvider({ children }) {
  const { authUser } = useContext(IdentityContext);
  const [project, setProject] = useState();

  const landingPath = window.location.pathname;
  const projectId = landingPath.split("/")[2];

  useEffect(() => {
    async function getLearningCentre(query) {
      const data = await API.get({
        url: query.url,
        params: query.params,
      });
      setProject(data);
    }
    async function initializeProject() {
      await getLearningCentre({
        url: `/admin/${projectId}?s=hnav`,
      });
    }
    if (!project && authUser) {
    // if (!project && authUser && typeof authUser === 'object') {
      initializeProject();
    }
  }, [authUser, project]);

  const context = {
    project,
    setProject
  };

  return (
    <ProjectContext.Provider value={context}>
      {children}
    </ProjectContext.Provider>
  );
}
